<template>
    <div>
        <div class="title">Viber Campaign Overview</div>
        <viber-campaign-details v-if="campaign.id" :campaign="campaign" />
    </div>
</template>

<script>
    import recurringViberCampaignService from '@/services/recurring-viber-campaign-service'
    import ViberCampaignDetails from '@/components/recurring/ViberCampaignDetails.vue'
    export default {
        components: { ViberCampaignDetails },
        data() {
            return {
                campaign: {}
            }
        },
        created() {
            this.fetchViberCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchViberCampaignById(id) {
                return recurringViberCampaignService.getViberCampaignById(id).then(resp => {
                    this.campaign = resp.data
                })
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
